import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import api from './api';
import DashboardLayout from './components/DashboardLayout';
import Welcome from './components/Welcome';
import BlogManager from './components/BlogManager';
import LoginPage from './components/LoginForm';
import NewsManager from './components/NewsManager';
import Preloader from './components/Preloader';
import Help from './components/help';


function App() {
  const [loggedIn, setLoggedIn] = useState(false);

  const [loading, setLoading] = useState(true);

useEffect(() => {
  const checkSession = async () => {
    const start = Date.now();

    try {
      const res = await api.get('/auth/session');
      setLoggedIn(true);
      console.log('Welcome back,', res.data.username);
    } catch {
      setLoggedIn(false);
    } finally {
      const elapsed = Date.now() - start;
      const delay = Math.max(0, 1000 - elapsed); // minimum 1.5s
      setTimeout(() => setLoading(false), delay);
    }
  };

  checkSession();
}, []);




  return (
    <Router>
      {loading ? (
         <Preloader />
      ) : (
        <Routes>
          <Route
            path="/"
            element={<LoginPage onLogin={() => setLoggedIn(true)} />}
          />
          <Route
            path="/dashboard"
            element={
              loggedIn ? (
                <DashboardLayout onLogout={() => setLoggedIn(false)} />
              ) : (
                <Navigate to="/" />
              )
            }
          >
            <Route index element={<Welcome />} />
            <Route path="blog" element={<BlogManager />} />
            <Route path='news' element={<NewsManager />} />
            <Route path='help' element={<Help />} />
          </Route>
        </Routes>
      )}
    </Router>
  );
}

export default App;